import { useMutation } from '@tanstack/react-query';
import { organizationsRepo } from '@/constants/providers';
import { ApiResponse } from '@/shared/types';

export const useDeleteOrganization = () =>
  useMutation<ApiResponse<unknown>, unknown, number>((id: number) =>
    organizationsRepo.deleteOrganization(id),
  );
